const structure = [
  {
    id: 0,
    label: 'Getting Started',
    link: '/documentation/getting-started',
    children: [
      {
        label: 'Quick start',
        link: '/documentation/getting-started/quick-start',
      },
    ],
  },
  {
    id: 2,
    label: 'Components',
    link: '/documentation/components',
    children: [
      {
        label: 'Typography',
        link: '/documentation/components/typography',
      },
      {
        label: 'Widget',
        link: '/documentation/components/widget',
      },
      {
        label: 'Header',
        link: '/documentation/components/header',
      },
      {
        label: 'Sidebar',
        link: '/documentation/components/sidebar',
      },
      {
        label: 'Buttons',
        link: '/documentation/components/buttons',
      },
    ],
  },
];

export default structure;
